import { asOptional } from './lang';

export function setValidationProperties<T = unknown>(
  properties: string[],
  field: object,
  propertyManipulations: { [field: string]: (value: T) => T } = {},
) {
  return properties.reduce<{ [key: string]: unknown }>((acc, key) => {
    const userValue = (field as { [key: string]: T })[key];
    const value = propertyManipulations[key]
      ? propertyManipulations[key](userValue)
      : userValue;
    if (
      typeof asOptional(value) !== 'undefined' &&
      !isEnumValidationPropertyArrayEmpty(key, value)
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function setValidationMessages(
  properties: string[],
  field: { validationMessages?: object },
): { errorMessage?: { [key: string]: string } } {
  if (field.validationMessages) {
    const customMessages = field.validationMessages as {
      [key: string]: string;
    };
    const errorMessage = properties.reduce<{ [key: string]: string }>(
      (acc, property) => {
        const propertyErrorMsg = customMessages[property];
        if (propertyErrorMsg) {
          acc[property] = propertyErrorMsg;
        }
        return acc;
      },
      {},
    );
    return {
      errorMessage,
    };
  }
  return {};
}

function isEnumValidationPropertyArrayEmpty(
  key: string,
  value: unknown,
): boolean {
  return key === 'enum' && Array.isArray(value) && !value.length;
}
